// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.multifamily.RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  CreateMultifamilyFeesRequestDto,
  GetMultifamilyFeesResponseDto,
  ListingAlias,
  MultifamilyFeeDto,
  UpdateFeedImportedMultifamilyFeesRequestDto,
  UpdateMultifamilyFeesRequestDto,
} from '../..';

interface DeleteParams {
  feeGroupId: string;
  listingAlias: ListingAlias;
}
interface GetParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Path =
  '/api/web/v1/users/properties/fees/multifamily/create';

/**
 * Creates one or more fees for a multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create = (
  postData: CreateMultifamilyFeesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreateMultifamilyFeesRequestDto, MultifamilyFeeDto>({
    endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/fees/multifamily/delete';

/**
 * Deletes a group of fees for a multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete = (
  getParams: DeleteParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<DeleteParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Path =
  '/api/web/v1/users/properties/fees/multifamily/get';

/**
 * Retrieve all fees for a given multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get = (
  getParams: GetParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetParams, never, GetMultifamilyFeesResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Path =
  '/api/web/v1/users/properties/fees/multifamily/update';

/**
 * Updates one or more fees for a multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update = (
  postData: UpdateMultifamilyFeesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdateMultifamilyFeesRequestDto, MultifamilyFeeDto>({
    endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Path =
  '/api/web/v1/users/properties/fees/multifamily/updateFeedImportedFees';

/**
 * Updates name and description of a group of fees imported from feed
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees = (
  postData: UpdateFeedImportedMultifamilyFeesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdateFeedImportedMultifamilyFeesRequestDto, MultifamilyFeeDto>({
    endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
